import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { formatNumber } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/phone-number.js';
import { ContextConsumer } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/controllers/context-consumer.js';
import { dynamicPhoneNumberContext } from '@cigna/cigna_csg_gsg_campaigns/lib/interfaces.js';
import '@cigna/cigna_csg_gsg_cipublic-link/cipublic-link.js';
import '@cigna/cigna_csg_gsg_cipublic-button/cipublic-button.js';
import styles from './phone-number.scss.js';
import linkStyles from './link.scss.js';
export class PhoneNumber extends CipublicElement {
    static get styles() {
        return [styles];
    }
    constructor() {
        super();
        this.separator = '-'; // hyphen, dot
        this.parentheses = false;
        this.isButton = false;
        this.mobileOnly = false;
        this.campaignOptIn = false;
        this.counter = 0;
        this.emitConnectedCallback = false;
        new ContextConsumer(this, dynamicPhoneNumberContext, (value) => (this.dynamicPhoneNumber = value), true);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
        this.classList.add('visually-hidden');
    }
    firstUpdated() {
        addStyleSheetToElements([this.phoneLink], linkStyles);
    }
    async willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        if (changedProperties.has('dynamicPhoneNumber')) {
            if (this.dynamicPhoneNumber && this.campaignOptIn) {
                this.number = this.dynamicPhoneNumber;
                await this.updateComplete;
                this.loadStaticPhone();
            }
        }
    }
    async updated() {
        await this.updateComplete;
        if (this.dynamicPhoneNumber && this.campaignOptIn) {
            this.emitLinkUpdate();
        }
        else {
            this.classList.remove('visually-hidden');
        }
    }
    loadStaticPhone() {
        if (window._satellite) {
            window.dispatchEvent(new CustomEvent('cipublic-phone-loaded', { detail: { phone: this } }));
        }
        else {
            this.counter += 1;
            if (this.counter < 25)
                setTimeout(() => this.loadStaticPhone(), 200);
            else
                return;
        }
    }
    emitLinkUpdate() {
        emit(this.phoneLink, 'link.updated');
        this.classList.remove('visually-hidden');
    }
    render() {
        let text;
        if (this.initialChildren === undefined) {
            this.initialChildren = Array.from(this.childNodes);
        }
        if (this.initialChildren.length) {
            text = this.initialChildren;
        }
        else {
            text = formatNumber(this.number, this.separator, this.parentheses);
        }
        const classes = { mobileonly: this.mobileOnly };
        if (this.isButton) {
            return html `<cipublic-button href="tel:+${formatNumber(this.number, '')}" class="${classMap(classes)}">${text}</cipublic-button>`;
        }
        return html `<cipublic-link href="tel:+${formatNumber(this.number, '')}" class="${classMap(classes)}">${text}</cipublic-link>`;
    }
}
__decorate([
    property({ reflect: true })
], PhoneNumber.prototype, "number", void 0);
__decorate([
    property({ reflect: true })
], PhoneNumber.prototype, "separator", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], PhoneNumber.prototype, "parentheses", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'is-button' })
], PhoneNumber.prototype, "isButton", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'is-mobile-only' })
], PhoneNumber.prototype, "mobileOnly", void 0);
__decorate([
    property({ reflect: true, type: Boolean, attribute: 'campaign-opt-in' })
], PhoneNumber.prototype, "campaignOptIn", void 0);
__decorate([
    state()
], PhoneNumber.prototype, "counter", void 0);
__decorate([
    state()
], PhoneNumber.prototype, "dynamicPhoneNumber", void 0);
__decorate([
    query('cipublic-link')
], PhoneNumber.prototype, "phoneLink", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], PhoneNumber.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=phone-number.js.map